
      var _path, _path2, _rect, _rect2, _rect3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCellcomDu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m84.228 13.72.223 56.422-12.17-.847-10.258 5.642a1 1 0 0 0-.454.525l-4.633 12.353s6.954 16.314 9.386 19.354c2.431 3.04-16.418 1.103-16.418 1.103l-23.375-2.783 1.691-91.768h56.008Z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M85.852 72.797V19.674a7.5 7.5 0 0 0-7.5-7.5H33.568a7.5 7.5 0 0 0-7.5 7.5v80.653a7.5 7.5 0 0 0 7.5 7.5h41.386",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 61.938,
  y: 25.127,
  width: 11.957,
  height: 4.384,
  rx: 2.192,
  transform: "rotate(-180 61.938 25.127)",
  fill: "var(--theme-primary, #810ea9)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 56.068,
  y: 69.965,
  width: 37.863,
  height: 37.863,
  rx: 18.931,
  fill: "var(--theme-light, #f9f3fb)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 56.068,
  y: 69.965,
  width: 37.863,
  height: 37.863,
  rx: 18.931,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M63.87 88.965h22.4M75.068 77.764v22.4",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M84.2284 13.7207L84.4508 70.142L72.2809 69.2954L62.023 74.9374C61.8137 75.0525 61.6525 75.2388 61.5686 75.4624L56.9365 87.8147C56.9365 87.8147 63.8898 104.129 66.3216 107.169C68.7534 110.209 49.9037 108.272 49.9037 108.272L26.5293 105.489L28.2203 13.7208L84.2284 13.7207Z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n<path d=\"M85.8516 72.7974L85.8516 19.6738C85.8516 15.5317 82.4937 12.1738 78.3516 12.1738L33.5685 12.1738C29.4264 12.1738 26.0685 15.5317 26.0685 19.6738L26.0685 84.7638L26.0685 100.327C26.0685 104.469 29.4264 107.827 33.5685 107.827L74.954 107.827\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<rect x=\"61.9375\" y=\"25.127\" width=\"11.9566\" height=\"4.38409\" rx=\"2.19204\" transform=\"rotate(-180 61.9375 25.127)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<rect x=\"56.0684\" y=\"69.9648\" width=\"37.8626\" height=\"37.8626\" rx=\"18.9313\" fill=\"var(--theme-light, #f9f3fb)\"/>\r\n<rect x=\"56.0684\" y=\"69.9648\" width=\"37.8626\" height=\"37.8626\" rx=\"18.9313\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\"/>\r\n<path d=\"M63.8691 88.9648H86.2691\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M75.0684 77.7637L75.0684 100.164\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/cellcomDu.5940b562ab7614ebe454201f9342a528.svg"),
        {
          React: SvgCellcomDu,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      